import { Fragment, useEffect, useState } from "react";
import { atom, useRecoilState } from "recoil";
import LineBox from "../../../components/DefaultStyles/LineBox";
import PageTitle from "../../../components/DefaultStyles/PageTitle";
import Table, {
  TableBody,
  TableBodyItem,
} from "../../../components/Table/Table";
import { useApi } from "../../../hooks/useApi";
import { getEllipsis, getThousandComma } from "../../../ApiTS/ApiCommonTS";
import LineBtn from "../../../components/Button/LineBtn";
import {
  ManageLogTableDetailContainer,
  ManageLogTableDetailContent,
} from "../../Manage/ManageLog";
import SpaceBetween from "../../../components/DefaultStyles/SpaceBetween";
import Pagination from "../../../components/Table/Pagination";
import { TotalCount } from "../../Users/UserInfo";
import styled from "styled-components";
import Flex from "../../../components/DefaultStyles/Flex";
import { useNavigate } from "react-router-dom";

interface ISuggest {
  id: number;
  uid: number;
  email: string;
  type: number;
  content: string;
  date: string;
}

const tableHead = [
  "NO",
  "의견 유형",
  "내용",
  "이메일 주소",
  "UID",
  "제안 일시",
  "상세",
];

export const suggestPageState = atom<number>({
  key: "suggestPageState",
  default: 0,
});

export default function Suggest() {
  const navigate = useNavigate();
  const [savedPage, setSavedPage] = useRecoilState<number>(suggestPageState);

  const [page, setPage] = useState(savedPage);

  useEffect(() => {
    setSavedPage(page);
  }, [page]);
  const [detail, setDetail] = useState(false);
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const { response, loading, fetchData } = useApi({
    method: "get",
    url: `suggest?page=${page}&size=10&`,
  });

  return (
    <>
      <PageTitle title="고객제안" />

      <LineBox>
        <Table tableHeadData={tableHead} tableMinWidth={1180}>
          <>
            {response?.data?.items?.map((d: ISuggest, i: number) => (
              <Fragment key={i}>
                <TableBody>
                  <TableBodyItem>{d.id}</TableBodyItem>
                  <TableBodyItem>
                    {d.type === 1
                      ? "신규 서비스 제안"
                      : d.type === 2
                      ? "제휴/마케팅 제안"
                      : d.type === 3
                      ? "기타"
                      : "-"}
                  </TableBodyItem>
                  <TableBodyItem>{getEllipsis(d.content, 20)}</TableBodyItem>
                  <TableBodyItem>
                    {d.email !== "" ? getEllipsis(d.email, 20) : "-"}
                  </TableBodyItem>
                  <TableBodyItem
                    clickable={d.uid > 0}
                    onClick={() => {
                      if (d.uid === 0) return;

                      setSavedPage(page);
                      navigate(`/users/info/${d.uid}`);
                    }}
                  >
                    {d.uid > 0 ? d.uid : "-"}
                  </TableBodyItem>
                  <TableBodyItem>{d.date}</TableBodyItem>
                  <TableBodyItem>
                    <LineBtn
                      btnText={activeIndex === i && detail ? "접기" : "상세"}
                      btnClickEvent={() => {
                        setActiveIndex(i);

                        if (activeIndex === i) {
                          // 열려있을 때
                          setDetail(!detail);
                        } else {
                          // 열기
                          setDetail(true);
                        }
                      }}
                    />
                  </TableBodyItem>
                </TableBody>

                {activeIndex === i && detail && (
                  <ManageLogTableDetailContainer>
                    <ManageLogTableDetailContent
                      colSpan={10}
                      style={{ color: "#2f2f38" }}
                    >
                      <Label style={{ marginBottom: 10 }}>내용</Label>

                      {d?.content}

                      {d?.email !== "" && (
                        <Flex style={{ marginTop: 24 }} gapSize={4}>
                          <Label>이메일 주소: </Label>
                          <>{d?.email}</>
                        </Flex>
                      )}
                    </ManageLogTableDetailContent>
                  </ManageLogTableDetailContainer>
                )}
              </Fragment>
            ))}
          </>
        </Table>

        <SpaceBetween>
          <Pagination
            totalPage={response?.status === 200 ? response.data.totalPage : 1}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
          />

          <TotalCount>
            총{" "}
            {getThousandComma(
              response?.status === 200 ? +response?.data?.totalCount : 0
            )}
            개
          </TotalCount>
        </SpaceBetween>
      </LineBox>
    </>
  );
}

const Label = styled.div`
  font-size: 13px;
  line-height: normal;
  color: #2f2f38;
  font-weight: bold;
`;
